/**
 * JeriCommerce Pass API · staging
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateCouponBatchShopifySegmentsContext { 
    /**
     * Restrict redemption to a Shopify customer segment.
     */
    type: CreateCouponBatchShopifySegmentsContext.TypeEnum;
    /**
     * Shopify customer segment GIDs allowed to redeem the discount.
     */
    segmentIds: Array<string>;
}
export namespace CreateCouponBatchShopifySegmentsContext {
    export const TypeEnum = {
        CustomerSegments: 'customer_segments'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


